module.exports = __webpack_public_path__ + "static/media/5.16.2984b3db.png";